import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState, useContext } from 'react';
import { ContabilidadContext } from 'akasia-components/Contabilidad/common/ContabilidadContext';
import { ContabilidadLayout } from 'akasia-components/Contabilidad/common/ContabilidadLayout';
import { Card, Col, Row } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import ModalMapeoCSV from './ModalMapeoCSV';
import ModalMovimientoManual from './ModalMovimientoManual';
import PanelEstadoCuenta from './panel-estado-cuenta/PanelEstadoCuenta';
import PanelFacturasConciliar from './panel-facturas-conciliar/PanelFacturasConciliar';

const ConciliarFacturasContent = () => {

    //AUTENTICACION
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**FILTROS GENERALES */
    const { selectedCompany } = useContext(ContabilidadContext);
    const rfcSeleccionado = selectedCompany?.vRFC || '';

    /**FILTROS */
    const [periodoEstadoCuenta, setPeriodoEstadoCuenta] = useState(new Date());
    const [periodoFacturas, setPeriodoFacturas] = useState(new Date());
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [moneda, setMoneda] = useState('');
    const [tipoMovimiento, setTipoMovimiento] = useState('');
    const [cargando, setCargando] = useState(false);
    const [cargandoFacturas, setCargandoFacturas] = useState(false);
    const [showModalManual, setShowModalManual] = useState(false);

    // Estado de cuenta
    const [movimientosBancarios, setMovimientosBancarios] = useState([]);
    const [movimientosFiltrados, setMovimientosFiltrados] = useState([]);

    // Facturas
    const [facturasFiltradas, setFacturasFiltradas] = useState([]);
    const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);

    // Modal de mapeo CSV
    const [showModalMapeo, setShowModalMapeo] = useState(false);
    const [datosCSV, setDatosCSV] = useState({ headers: [], rows: [] });
    const [mapeoColumnas, setMapeoColumnas] = useState({
        identificador: '',
        fecha: '',
        descripcion: '',
        monto: '',
        tipo: '',
        referencia: '',
        moneda: '',
        tipoCambio: ''
    });
    const [archivoTemporal, setArchivoTemporal] = useState(null);

    // Configuración adicional para el modal
    const [cuentasBancarias, setCuentasBancarias] = useState([]);
    const [cuentaSeleccionada, setCuentaSeleccionada] = useState('');
    const [tipoMovimientoDefault, setTipoMovimientoDefault] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
        }
        checkPermisos();
        cargarCuentasBancarias();
    }, []);

    /**
     * Aplica filtros cuando cambian
     */
    useEffect(() => {
        aplicarFiltrosMovimientos();
    }, [tipoMovimiento, periodoEstadoCuenta, movimientosBancarios, rfcSeleccionado]);

    useEffect(() => {
        if (rfcSeleccionado) {
            obtenerFacturas();
            cargarCuentasBancarias();
        } else {
            setFacturasFiltradas([]);
            setCuentasBancarias([]);
        }
    }, [tipoDocumento, moneda, periodoFacturas, rfcSeleccionado]);

    useEffect(() => {
        if (cuentaSeleccionada && periodoEstadoCuenta) {
            obtenerMovimientosBancarios();
        } else {
            setMovimientosBancarios([]);
            setMovimientosFiltrados([]);
        }
    }, [cuentaSeleccionada, periodoEstadoCuenta]);

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {
        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();
            console.log(responseType);

            if (responseType.iResponseType == 1) {
                // Permisos verificados
            } else {
                navigate("/");
            }
        }
        else {
            navigate("/");
        }
    }

    const idDatoFiscalSeleccionado = selectedCompany?.idDatoFiscal || null;

    /**
     * Carga el catálogo de cuentas bancarias
     */
    const cargarCuentasBancarias = async () => {
        if (!rfcSeleccionado || !idDatoFiscalSeleccionado) {
            setCuentasBancarias([]);
            return;
        }
        try {
            const response = await fetch("/api/contabilidad/bancos/Conciliacion/ObtenerCuentasBancariasPorEmpresa", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idDatoFiscal: idDatoFiscalSeleccionado })
            });

            if (response.ok) {
                const resultado = await response.json();

                if (resultado.iResponseType === 1) {
                    const cuentas = JSON.parse(resultado.detalles || "[]");
                    setCuentasBancarias(cuentas);
                } else {
                    showErrorToast('No se pudieron cargar las cuentas bancarias');
                }
            }
        } catch (error) {
            console.error('Error al cargar cuentas bancarias:', error);
            showErrorToast('Error al cargar cuentas bancarias');
        }
    };

    /**
     * Aplica filtros a los movimientos bancarios
     */
    const aplicarFiltrosMovimientos = () => {
        let movimientosFiltrados = [...movimientosBancarios];

        // Filtrar por RFC
        if (rfcSeleccionado) {
            movimientosFiltrados = movimientosFiltrados.filter(m => m.rfc === rfcSeleccionado);
        }

        if (tipoMovimiento) {
            movimientosFiltrados = movimientosFiltrados.filter(m => m.tipo === tipoMovimiento);
        }

        // Filtrar por período mensual
        const mesSeleccionado = periodoEstadoCuenta.getMonth();
        const anioSeleccionado = periodoEstadoCuenta.getFullYear();
        movimientosFiltrados = movimientosFiltrados.filter(m => {
            const fechaMovimiento = new Date(m.fecha);
            return fechaMovimiento.getMonth() === mesSeleccionado &&
                fechaMovimiento.getFullYear() === anioSeleccionado;
        });

        setMovimientosFiltrados(movimientosFiltrados);
    };

    /**
     * Obtiene facturas desde el backend
     */
    const obtenerFacturas = async () => {
        try {
            setCargandoFacturas(true);
            const month = (periodoFacturas.getMonth() + 1).toString().padStart(2, '0');
            const year = periodoFacturas.getFullYear().toString();

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ObtenerFacturasConciliacion', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    rfc: rfcSeleccionado,
                    month: month,
                    year: year,
                    tipoDocumento: tipoDocumento || "",
                    moneda: moneda || ""
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const facturasObtenidas = JSON.parse(data.detalles || "[]");
                    setFacturasFiltradas(facturasObtenidas);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener facturas');
                    setFacturasFiltradas([]);
                }
            } else {
                showErrorToast('Error al obtener facturas');
                setFacturasFiltradas([]);
            }
        } catch (error) {
            console.error(error);
            showErrorToast('Error al conectar con el servidor');
            setFacturasFiltradas([]);
        } finally {
            setCargandoFacturas(false);
        }
    };

    /**
     * Obtiene los movimientos bancarios de la BD para la cuenta seleccionada
     */
    const obtenerMovimientosBancarios = async () => {
        if (!cuentaSeleccionada) return;
        try {
            setCargando(true);
            const month = (periodoEstadoCuenta.getMonth() + 1).toString().padStart(2, '0');
            const year = periodoEstadoCuenta.getFullYear().toString();

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ObtenerMovimientosBancarios', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idCatCuentaBancaria: cuentaSeleccionada,
                    month: month,
                    year: year
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const movs = JSON.parse(data.detalles || "[]");
                    setMovimientosBancarios(movs);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener movimientos bancarios');
                    setMovimientosBancarios([]);
                }
            } else {
                showErrorToast('Error al obtener movimientos bancarios');
                setMovimientosBancarios([]);
            }
        } catch (error) {
            console.error(error);
            showErrorToast('Error al conectar con el servidor (Movimientos)');
            setMovimientosBancarios([]);
        } finally {
            setCargando(false);
        }
    };

    /**
     * Lee y parsea el archivo CSV para mostrar en el modal
     */
    const leerArchivoCSV = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const text = e.target.result;
                const lines = text.split('\n').filter(line => line.trim() !== '');

                if (lines.length === 0) {
                    showErrorToast("El archivo CSV está vacío");
                    return;
                }

                // Primera línea son los headers
                const headers = lines[0].split(',').map(h => h.trim());

                // Resto son los datos (máximo 5 filas para preview)
                const rows = lines.slice(1, Math.min(6, lines.length)).map(line => {
                    return line.split(',').map(cell => cell.trim());
                });

                setDatosCSV({ headers, rows });

                // Intentar mapeo automático inteligente
                const mapeoAuto = mapeoAutomaticoColumnas(headers);
                setMapeoColumnas(mapeoAuto);

                setArchivoTemporal(file);
                setShowModalMapeo(true);
            } catch (error) {
                showErrorToast("Error al leer el archivo CSV: " + error.message);
            }
        };

        reader.onerror = () => {
            showErrorToast("Error al leer el archivo");
        };

        reader.readAsText(file, 'UTF-8');
    };

    /**
     * Mapeo automático inteligente de columnas
     */
    const mapeoAutomaticoColumnas = (headers) => {
        const mapeo = {
            identificador: '',
            fecha: '',
            descripcion: '',
            monto: '',
            tipo: '',
            referencia: '',
            moneda: '',
            tipoCambio: ''
        };

        headers.forEach((header, index) => {
            const headerLower = header.toLowerCase();

            // Mapeo de identificador
            if (headerLower.includes('id') || headerLower.includes('identificador') ||
                headerLower.includes('folio') || headerLower.includes('numero')) {
                mapeo.identificador = index.toString();
            }

            // Mapeo de fecha
            if (headerLower.includes('fecha') || headerLower.includes('date')) {
                mapeo.fecha = index.toString();
            }

            // Mapeo de descripción
            if (headerLower.includes('descripcion') || headerLower.includes('concepto') ||
                headerLower.includes('description') || headerLower.includes('detalle')) {
                mapeo.descripcion = index.toString();
            }

            // Mapeo de monto
            if (headerLower.includes('monto') || headerLower.includes('importe') ||
                headerLower.includes('amount') || headerLower.includes('total')) {
                mapeo.monto = index.toString();
            }

            // Mapeo de tipo
            if (headerLower.includes('tipo') || headerLower.includes('type') ||
                headerLower.includes('movimiento') || headerLower.includes('cargo') ||
                headerLower.includes('abono')) {
                mapeo.tipo = index.toString();
            }

            // Mapeo de referencia
            if (headerLower.includes('referencia') || headerLower.includes('reference') ||
                headerLower.includes('ref')) {
                mapeo.referencia = index.toString();
            }

            // Mapeo de moneda
            if (headerLower.includes('moneda') || headerLower.includes('currency') ||
                headerLower.includes('divisa')) {
                mapeo.moneda = index.toString();
            }

            // Mapeo de tipo de cambio
            if ((headerLower.includes('tipo') && headerLower.includes('cambio')) ||
                headerLower.includes('tipocambio') || headerLower.includes('tc') ||
                headerLower.includes('exchange')) {
                mapeo.tipoCambio = index.toString();
            }
        });

        return mapeo;
    };

    /**
     * Maneja la selección inicial del archivo
     */
    const handleSeleccionarArchivo = (e) => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        if (!rfcSeleccionado) {
            showErrorToast("Debe seleccionar un RFC antes de importar");
            e.target.value = '';
            return;
        }

        // Validar extensión
        const extension = file.name.split('.').pop().toLowerCase();
        if (extension !== 'csv') {
            showErrorToast("Solo se permiten archivos CSV");
            e.target.value = '';
            return;
        }

        // Validar tamaño (5MB máximo)
        if (file.size > 5 * 1024 * 1024) {
            showErrorToast("El archivo no debe superar los 5MB");
            e.target.value = '';
            return;
        }

        // Leer y mostrar modal de mapeo
        leerArchivoCSV(file);

        // Limpiar el input
        e.target.value = '';
    };

    /**
     * Confirma el mapeo y procesa la importación
     */
    const confirmarImportacion = async () => {
        // Validar que todos los campos obligatorios estén mapeados
        const camposObligatorios = ['identificador', 'fecha', 'descripcion', 'monto', 'referencia'];
        const camposFaltantes = camposObligatorios.filter(campo => !mapeoColumnas[campo]);

        if (camposFaltantes.length > 0) {
            showErrorToast(`Debe mapear los siguientes campos obligatorios: ${camposFaltantes.join(', ')}`);
            return;
        }

        try {
            setCargando(true);
            setShowModalMapeo(false);

            const formData = new FormData();
            formData.append('file', archivoTemporal);
            formData.append('rfcEmisor', rfcSeleccionado);
            formData.append('idCatCuentaBancaria', cuentaSeleccionada);
            formData.append('tipoMovimientoDefault', tipoMovimientoDefault);
            formData.append('mapeoColumnas', JSON.stringify(mapeoColumnas));

            const response = await fetch('/api/contabilidad/bancos/conciliacion/ImportarEstadoCuenta', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: formData
            });

            if (response.ok) {
                const resultado = await response.json();

                if (resultado.iResponseType === 1) {
                    showSuccessToast(resultado.vMessage);
                    // Recargar los movimientos bancarios
                    aplicarFiltrosMovimientos();
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error al importar: ${response.status} ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error al importar estado de cuenta:', error);
            showErrorToast('Error al procesar el archivo: ' + error.message);
        } finally {
            setCargando(false);
            setArchivoTemporal(null);
            setCuentaSeleccionada('');
            setTipoMovimientoDefault('');
        }
    };

    /**
     * Cancela el modal de mapeo
     */
    const cancelarMapeo = () => {
        setShowModalMapeo(false);
        setArchivoTemporal(null);
        setDatosCSV({ headers: [], rows: [] });
        setMapeoColumnas({
            identificador: '',
            fecha: '',
            descripcion: '',
            monto: '',
            tipo: '',
            referencia: '',
            moneda: '',
            tipoCambio: ''
        });
        setCuentaSeleccionada('');
        setTipoMovimientoDefault('');
    };

    /**
     * Calcula totales de movimientos bancarios
     */
    const calcularTotales = () => {
        const ingresos = movimientosFiltrados
            .filter(m => m.tipo === 'ingreso')
            .reduce((sum, m) => sum + m.monto, 0);

        const egresos = movimientosFiltrados
            .filter(m => m.tipo === 'egreso')
            .reduce((sum, m) => sum + m.monto, 0);

        return { ingresos, egresos, neto: ingresos - egresos };
    };

    const totales = calcularTotales();

    const toggleSeleccionFactura = (factura) => {
        setFacturasSeleccionadas(prev => {
            const isSelected = prev.some(f => f.id === factura.id);
            if (isSelected) {
                return prev.filter(f => f.id !== factura.id);
            } else {
                return [...prev, factura];
            }
        });
    };

    const totalFacturasSeleccionadas = facturasSeleccionadas.reduce((sum, f) => {
        const total = f.tipo === 'E' ? -Math.abs(f.total) : f.total;
        const totalMXN = total * (f.tipoCambio || 1);
        return sum + totalMXN;
    }, 0);



    return (
        <>
            {/* Header */}


            {!rfcSeleccionado && (
                <Card className="mb-3 shadow-sm border-warning">
                    <Card.Body className="p-3 bg-soft-warning">
                        <div className="d-flex align-items-center">
                            <i className="fas fa-exclamation-triangle fa-2x text-warning me-3"></i>
                            <div>
                                <h6 className="mb-1 text-warning-dark">Atención: No hay empresa seleccionada</h6>
                                <p className="mb-0 fs--1 text-800">Por favor, seleccione una empresa en la parte superior para visualizar los movimientos bancarios y facturas correspondientes.</p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            )}

            <ModalMovimientoManual
                show={showModalManual}
                onHide={() => setShowModalManual(false)}
                rfcSeleccionado={rfcSeleccionado}
                idDatoFiscal={idDatoFiscalSeleccionado}
                onSuccess={() => {
                    cargarCuentasBancarias();
                }}
            />

            {/* Modal de Mapeo de Columnas CSV */}
            <ModalMapeoCSV
                show={showModalMapeo}
                onHide={cancelarMapeo}
                onConfirm={confirmarImportacion}
                datosCSV={datosCSV}
                mapeoColumnas={mapeoColumnas}
                setMapeoColumnas={setMapeoColumnas}
                cuentasBancarias={cuentasBancarias}
                cuentaSeleccionada={cuentaSeleccionada}
                setCuentaSeleccionada={setCuentaSeleccionada}
                tipoMovimientoDefault={tipoMovimientoDefault}
                setTipoMovimientoDefault={setTipoMovimientoDefault}
            />

            {/* Sección Principal: Estado de Cuenta y Facturas */}
            <Row className="g-3">
                {/* Columna Izquierda: Estado de Cuenta */}
                <Col lg={6}>
                    <PanelEstadoCuenta
                        rfcSeleccionado={rfcSeleccionado}
                        cargando={cargando}
                        periodoEstadoCuenta={periodoEstadoCuenta}
                        setPeriodoEstadoCuenta={setPeriodoEstadoCuenta}
                        tipoMovimiento={tipoMovimiento}
                        setTipoMovimiento={setTipoMovimiento}
                        totales={totales}
                        movimientosFiltrados={movimientosFiltrados}
                        handleSeleccionarArchivo={handleSeleccionarArchivo}
                        onAgregarManual={() => setShowModalManual(true)}
                        cuentasBancarias={cuentasBancarias}
                        cuentaSeleccionada={cuentaSeleccionada}
                        setCuentaSeleccionada={setCuentaSeleccionada}
                    />
                </Col>

                {/* Columna Derecha: Facturas */}
                <Col lg={6}>
                    <PanelFacturasConciliar
                        rfcSeleccionado={rfcSeleccionado}
                        cargandoFacturas={cargandoFacturas}
                        facturasFiltradas={facturasFiltradas}
                        facturasSeleccionadas={facturasSeleccionadas}
                        setFacturasSeleccionadas={setFacturasSeleccionadas}
                        totalFacturasSeleccionadas={totalFacturasSeleccionadas}
                        toggleSeleccionFactura={toggleSeleccionFactura}
                        periodoFacturas={periodoFacturas}
                        setPeriodoFacturas={setPeriodoFacturas}
                        tipoDocumento={tipoDocumento}
                        setTipoDocumento={setTipoDocumento}
                        moneda={moneda}
                        setMoneda={setMoneda}
                    />
                </Col>
            </Row>
        </>
    );
};

const ConciliarFacturas = () => {
    return (
        <ContabilidadLayout
            title={
                <><i className="fas fa-file-invoice-dollar me-2" />Conciliación de Facturas</>
            }
        >
            <ConciliarFacturasContent />
        </ContabilidadLayout>
    );
};

export default ConciliarFacturas;




